import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { SvgIcon } from "@mui/material";
const EzIconMui = forwardRef(
  ({ color, fontSize, children, title, ...props }, ref) => {
    const isCommonColor = color == null ? void 0 : color.startsWith("common.");
    return /* @__PURE__ */ jsx(
      SvgIcon,
      {
        color: isCommonColor ? void 0 : color,
        ref,
        sx: {
          color: isCommonColor ? color : void 0,
          fill: "currentColor",
          fontSize
        },
        titleAccess: title,
        ...props,
        children
      }
    );
  }
);
EzIconMui.displayName = "EzIconMui";
export {
  EzIconMui as default
};
//# sourceMappingURL=EzIconMui.es.js.map
